/** The trip's end date. Day 1 IS the start date, so an 11-day trip ends on
 *  start + 10 — not start + 11, which would claim a night the tour does not
 *  include. Null duration → null, and the caller shows the start alone.
 *
 *  Shared because two surfaces state this date to the traveller — the departure
 *  rows and the add-to-cart confirmation — and a booking that ends on a
 *  different day depending on where you read it is worse than one that only
 *  ever shows the start. */
export function endDateFor(
  startIso: string,
  durationDays: number | null,
): Date | null {
  if (!durationDays || durationDays < 2) return null;
  const d = new Date(`${startIso}T00:00:00`);
  d.setDate(d.getDate() + durationDays - 1);
  return d;
}
